/**
 * Compact enum fields on the wire only; Firestore + UI keep full strings.
 */

import type { Booking } from "../types";

/** Subset of Booking fields that may be sent on the wire as enums. */
export type WireEncodableBookingFields = Partial<
  Pick<Booking, "status" | "paymentStatus" | "jobStatus" | "frequency">
>;

const STATUS_STR_TO_CODE: Record<string, number> = {
  Pending: 1,
  Confirmed: 2,
  Completed: 3,
  new_request: 4,
  Deleted: 5,
};

const PAYMENT_STR_TO_CODE: Record<string, number> = {
  Paid: 1,
  Unpaid: 2,
  "Verification Pending": 3,
};

const JOB_STR_TO_CODE: Record<string, number> = {
  Scheduled: 1,
  "En Route": 2,
  "In Progress": 3,
  Completed: 4,
};

const FREQ_STR_TO_CODE: Record<string, number> = {
  "One-time": 1,
  Weekly: 2,
  "Bi-weekly": 3,
  Monthly: 4,
};

export type EncodeInput = Record<string, unknown> & WireEncodableBookingFields;

export function encodeBookingFieldsForWire(obj: EncodeInput): Record<string, unknown> {
  const out: Record<string, unknown> = { ...obj };
  if (typeof out.status === "string" && STATUS_STR_TO_CODE[out.status] != null) {
    out.status = STATUS_STR_TO_CODE[out.status]!;
  }
  if (typeof out.paymentStatus === "string" && PAYMENT_STR_TO_CODE[out.paymentStatus] != null) {
    out.paymentStatus = PAYMENT_STR_TO_CODE[out.paymentStatus]!;
  }
  if (typeof out.jobStatus === "string" && JOB_STR_TO_CODE[out.jobStatus] != null) {
    out.jobStatus = JOB_STR_TO_CODE[out.jobStatus]!;
  }
  if (typeof out.frequency === "string" && FREQ_STR_TO_CODE[out.frequency] != null) {
    out.frequency = FREQ_STR_TO_CODE[out.frequency]!;
  }
  return out;
}
